const CDN_BASE = 'https://cdn.beebot.io';
const S3_PATTERNS = [
  'https://beebot.s3.us-east-1.amazonaws.com',
  'https://beebot.s3.amazonaws.com',
];

/**
 * Rewrites Beebot S3 URLs to the CDN so images/documents can be viewed and downloaded.
 * @param {string} url - URL from backend (may be S3 or already CDN)
 * @returns {string} CDN URL or original if not a Beebot S3 URL
 */
export const toCdnUrl = (url) => {
  if (!url || typeof url !== 'string') return url;
  for (const base of S3_PATTERNS) {
    if (url.startsWith(base)) {
      return CDN_BASE + url.slice(base.length);
    }
  }
  return url;
};

export const onDownload = (video) => {
  window.open(toCdnUrl(video), '_self');
};
